import { render } from "./BudgetListLayout.vue?vue&type=template&id=4de77606"
import script from "./BudgetListLayout.vue?vue&type=script&lang=js"
export * from "./BudgetListLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__